/* oxlint-disable */
import { css } from 'lit';

export default css`:host {
  color-scheme: inherit;
  display: inline-flex;
  --_font-size: var(--type-link--font-size, inherit);
  --_font-weight: var(--type-link--font-weight, inherit);
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.type-link {
  color: var(--link-color);
  text-decoration: none;
}
.type-link:hover {
  color: var(--link-color--hover);
}
.type-link:focus-visible {
  outline: 2px solid var(--link-color);
  outline-offset: 2px;
}
.type-link {
  font-size: var(--_font-size);
  font-weight: var(--_font-weight);
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.type-link[target=_blank]::after {
  content: "";
  display: inline-block;
  flex-shrink: 0;
  margin-left: 0.25rem;
  width: 1em;
  height: 1em;
  background-color: currentColor;
  -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -960 960 960'%3E%3Cpath d='M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h240q17 0 28.5 11.5T480-800q0 17-11.5 28.5T440-760H200v560h560v-240q0-17 11.5-28.5T800-480q17 0 28.5 11.5T840-440v240q0 33-23.5 56.5T760-120H200Zm560-584L416-360q-11 11-28 11t-28-11q-11-11-11-28t11-28l344-344H600q-17 0-28.5-11.5T560-800q0-17 11.5-28.5T600-840h200q17 0 28.5 11.5T840-800v200q0 17-11.5 28.5T800-560q-17 0-28.5-11.5T760-600v-104Z'/%3E%3C/svg%3E") no-repeat center/contain;
  mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 -960 960 960'%3E%3Cpath d='M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h240q17 0 28.5 11.5T480-800q0 17-11.5 28.5T440-760H200v560h560v-240q0-17 11.5-28.5T800-480q17 0 28.5 11.5T840-440v240q0 33-23.5 56.5T760-120H200Zm560-584L416-360q-11 11-28 11t-28-11q-11-11-11-28t11-28l344-344H600q-17 0-28.5-11.5T560-800q0-17 11.5-28.5T600-840h200q17 0 28.5 11.5T840-800v200q0 17-11.5 28.5T800-560q-17 0-28.5-11.5T760-600v-104Z'/%3E%3C/svg%3E") no-repeat center/contain;
}
.type-link.is-disabled {
  cursor: default;
  pointer-events: none;
  opacity: 0.4;
}

.type-link--generated {
  word-wrap: break-word;
  word-break: break-word;
}

.type-link__icon {
  height: 1.25em; /* Magic: Always equals 24px (or whatever parent is) */
  width: 1.25em;
  line-height: 1;
  margin-right: 0.25rem;
  flex-shrink: 0;
  aspect-ratio: 1/1;
}

.type-link__text {
  min-width: 0;
}`;
